import { defineComponent, computed } from 'vue';
import { RouterLink } from 'vue-router';

/**
 * Used for links that should trigger side effects on click. Note that side
 * effects will not be triggered when the user middle-clicks or right clicks
 * to open in a new tab.
 *
 * Typically this component would not be used directly as it is unstyled.
 * Instead, it should be implemented inside styled components.
 *
 * TODO: Implement in ButtonComponent
 *
 * Inspired by https://github.com/vuejs/router/issues/846#issuecomment-1475599431
 */
var script = defineComponent({
    name: 'ClickableRouterLink',
    components: {
        RouterLink,
    },
    props: {
        to: {
            type: [String, Object],
            default: null,
        },
    },
    setup(props, { emit }) {
        const emitClick = (event) => {
            emit('click', event);
        };
        const handleClick = (event, navigate) => {
            emitClick(event);
            navigate(event);
        };
        const computedTo = computed(() => { var _a; return (_a = props.to) !== null && _a !== void 0 ? _a : ''; });
        return {
            computedTo,
            emitClick,
            handleClick,
        };
    },
});

export { script as default };
